import React, {useEffect, useState} from 'react';
import {Button, ConfigProvider, DatePickerProps, Form, Modal} from 'antd';
import Colors from "../../../styles/Colors";
import 'dayjs/locale/es';
import dayjs from "dayjs";
import {Escola} from "../../../model/root/Escola";
import {GetInscripcionsEscoles} from "../../../dao/inscripcions/GetInscripcionsEscoles";
import {useParams} from "react-router-dom";
import locale from "antd/es/locale/es_ES";

interface PagadorModalProps {
    visible: boolean;
    page: string,
    onClose: (val: boolean) => void;
}

const NouUsuariModal: React.FC<PagadorModalProps> = ({visible, onClose, page}) => {
    const [form] = Form.useForm();
    const [escoles, setEscoles] = useState<Escola[]>([]);

    const {id_inscripcio} = useParams();

    useEffect(() => {
        checkOptions();
    }, []);

    async function checkOptions() {
        const esc = await GetInscripcionsEscoles(page);
        setEscoles(esc);
    }

    async function handleSubmit() {
        const formData = form.getFieldsValue();
        const newData = {...formData, data_naix: formData.data_naix2};
        ////console.log("Form Data:", newData);
        //await PostInscripcioInfant(newData, id_inscripcio +"", page);
        onClose(true);
    }

    const handleCancel = () => {
        onClose(false);
    };


    const dateFormatEs = 'DD-MM-YYYY';

    const customWeekStartEndFormatDayA: DatePickerProps['format'] = (value) =>
        `${dayjs(value).format(dateFormatEs)}`;

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="NOU USUARI"
            visible={visible}
            onCancel={handleCancel}
            footer={[]}
            maskClosable={false}
            width={window.innerWidth < 768 ? "90%" : "30%"}
        >
            <Form form={form} onFinish={handleSubmit}>
                <p>No s'han trobat les dades. <b>Vols crear un nou usuari amb les dades introduides?</b></p><br/>
                <Form.Item wrapperCol={{offset: 0, span: 16}}>
                    <Button title={"Aceptar"} htmlType={"submit"} style={{backgroundColor: Colors.colors.color6}}
                    >CREAR NOU USUARI</Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color4}}
                            onClick={handleCancel}>CANCELAR</Button>
                </Form.Item>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default NouUsuariModal;
